import {LineItem} from "../dtos/orderResponse"

export const isDeliverableOrder = (lineItems: Array<LineItem>): boolean => {
	return lineItems.every((lineItem) => lineItem.isDeliverable)
}
